import { Type } from "lucide-react";
import React, { useMemo } from "react";

import { TextMod } from "@src/store/slices/experienceBuilder/types";
import { ModificationListItem } from "@src/features/experienceBuilder/modifications/common/ModificationListItem";

export const TextListItem = ({ mod }: { mod: TextMod }) => {
  const subtitle = useSubtitle(mod);
  return (
    <ModificationListItem
      mod={mod}
      icon={<Type size={16} />}
      title={"Text modification"}
      subtitle={subtitle}
    />
  );
};

function useSubtitle(mod: TextMod) {
  return useMemo(() => {
    if (mod.description) return mod.description;

    const parts: string[] = [];
    if (mod.find) {
      parts.push(`\u201C${mod.find}\u201D`);
    }
    if (mod.replace) {
      parts.push(`\u201C${mod.replace}\u201D`);
    }
    return parts.join(" \u2192 ");
  }, [mod]);
}
